import { render, staticRenderFns } from "./Restreams.vue?vue&type=template&id=1f06e460&scoped=true&"
import script from "./Restreams.vue?vue&type=script&lang=js&"
export * from "./Restreams.vue?vue&type=script&lang=js&"
import style0 from "./Restreams.vue?vue&type=style&index=0&id=1f06e460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06e460",
  null
  
)

export default component.exports